import React, { useState, useEffect } from "react";
import { Container, Accordion, Button } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/IJOTPromotions.css"; // ✅ use same style for consistency
import "../styles/IJOTIssues.css"; // keep extra issue-specific tweaks

const IJOTIssues = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [groupedData, setGroupedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🕒 Token watcher (like promotions)
  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) setTokenState(currentToken);
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // 🧭 Login redirections (same as promotions)
  const handleMemberLogin = () => navigate("/member-login");
  const handleEdcclogin = () => navigate("/edcc-login");

  // 🧩 Fetch all IJOT issues
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASEURL}/get-all-ijot-issues`);
        const data = await response.json();

        if (!data.success) throw new Error(data.message);

        // 🔹 Group by Volume (maincategory)
        const grouped = data.data.reduce((acc, issue) => {
          const volume = issue.mainid?.maincategory || "Uncategorized Volume";
          const subcat = issue.subid?.subcat || "Unknown Issue";

          if (!acc[volume]) acc[volume] = new Set();
          acc[volume].add(JSON.stringify({ subcat, subid: issue.subid?._id }));
          return acc;
        }, {});

        const formatted = Object.entries(grouped).map(([volume, issues]) => ({
          title: volume,
          issues: Array.from(issues).map((i) => JSON.parse(i)),
        }));

        setGroupedData(formatted);
      } catch (err) {
        console.error("Error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // 🔗 Go to issue details page
  const handleIssueClick = (subid) => {
    navigate(`/ijot-issues/${subid}`);
  };

  return (
    <>
      {/* ✅ Hero Section (Same as Promotions Page) */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ✅ Scrollable Section (Same Layout as Promotions Page) */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="ijot-promotion-section">
            <Container className="mt-5">
              <h2 className="text-center ijot-promotions-heading mb-2">
                IJOT Issues
              </h2>
              <h6 className="text-center mb-4">
                For IJOT Issues starting from 2018 Volume 50 onward
              </h6>

              {/* Loading */}
              {loading && (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3">Loading IJOT issues...</p>
                </div>
              )}

              {/* Error */}
              {error && (
                <div
                  className="alert alert-danger text-center"
                  role="alert"
                >
                  {error}
                  <br />
                  <small>Check console for more details</small>
                </div>
              )}

              {/* Accordion Section */}
              {!loading && !error && groupedData.length > 0 ? (
                <Accordion alwaysOpen>
                  {groupedData.map((volume, vIndex) => (
                    <Accordion.Item
                      key={vIndex}
                      eventKey={vIndex.toString()}
                      className="mb-3 shadow-sm rounded"
                    >
                      <Accordion.Header>{volume.title}</Accordion.Header>
                      <Accordion.Body className="bg-light">
                        {volume.issues.map((issue, iIndex) => (
                          <Button
                            key={iIndex}
                            variant="outline-primary"
                            className="w-100 mb-2 text-start p-3 rounded"
                            onClick={() => handleIssueClick(issue.subid)}
                          >
                            {issue.subcat}
                          </Button>
                        ))}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              ) : (
                !loading &&
                !error && (
                  <div className="text-center py-5">
                    <p className="text-muted">No IJOT issues found.</p>
                  </div>
                )
              )}
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default IJOTIssues;
